<script setup>
import { useMainStore } from '../stores/main-store'

const mainStore = useMainStore()

const props = defineProps({
  term: {
    type: Object,
    default: () => {},
  },
  attribute: {
    type: Object,
    default: () => {},
  },
  name: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <label>
    <input
      v-model="mainStore[props.name][props.attribute.slug][props.term.slug]"
      type="checkbox"
      :name="term.slug"
    />
    <span>{{ term.title }}</span>
  </label>
</template>
